function escapeHtml(value) {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;");
}

export function availableCostCentersFrom(me, dictionaries) {
  const accessible = me?.accessible_cost_centers || [];
  return accessible.length ? accessible : dictionaries?.cost_centers || [];
}

export function referenceCostCentersFrom(me, dictionaries) {
  return dictionaries?.cost_centers || availableCostCentersFrom(me, dictionaries);
}

export function costCenterOptionsHtml(centers) {
  return (centers || [])
    .map((center) => `<option value="${escapeHtml(center.code)}">${escapeHtml(center.code)} · ${escapeHtml(center.name)}</option>`)
    .join("");
}

export function costCenterScopeNote(me, operationalCenters, referenceCenters) {
  const actor = me?.actor;
  const centers = operationalCenters || [];
  const allCenters = referenceCenters || centers;
  const allCentersCount = allCenters.length || centers.length;
  const isScoped = Boolean(actor?.cost_center_code) || centers.length < allCentersCount;
  if (isScoped) {
    const label = actor?.display_name || actor?.role || "пользователя";
    const codes = centers.map((center) => center.code).join(", ") || "назначенное подразделение";
    return `Операционные формы ограничены профилем ${label}: доступно ${codes}. В полном справочнике ${allCentersCount} кост-центров.`;
  }
  return `Доступно ${centers.length} кост-центров из справочника. Выберите нужный из списка.`;
}
